import { useCluster } from "in_queue/contexts/ClusterContext";
import { useSubscriptionForCluster } from "in_queue/contexts/ProjectDataContext";
import { ScenarioStage } from "in_queue/types/scenarioType";
import { getViewableScenarioStagesForSubscription } from "in_queue/utils/scenarios";
import { useSearchParams } from "react-router-dom";
import { SCENARIO_STAGE_PARAM } from "./scenarioBuilderParams";

/** The stage the URL asks for, or the subscription's default when it names none. */
export const useRequestedScenarioStage = (): ScenarioStage => {
    const [searchParams] = useSearchParams();
    const cluster = useCluster();
    const subscription = useSubscriptionForCluster();

    const stageParam = searchParams.get(SCENARIO_STAGE_PARAM);
    if (stageParam === "PREVIEW" || stageParam === "DECISION_POINT") {
        return stageParam;
    }

    const viewableStages = getViewableScenarioStagesForSubscription(
        cluster,
        subscription === "loading" ? undefined : subscription
    );
    return viewableStages.has("DECISION_POINT") ? "DECISION_POINT" : "PREVIEW";
};
